import { StorefrontFeature } from '@ordering/gql/graphql';

export const isOrderingEnabled = (features?: StorefrontFeature[] | null) =>
  !features?.length || features.includes(StorefrontFeature.Ordering);

export const isMenuBrowsingOnly = (features?: StorefrontFeature[] | null) => !isOrderingEnabled(features);
